import React, { useRef, useEffect } from 'react';
import ClipboardJS from 'clipboard';

const CopyButton = ({ text }) => {
  const buttonRef = useRef(null);
  let clipboard = null;

  useEffect(() => {
    // Khởi tạo ClipboardJS với ref của nút
    clipboard = new ClipboardJS(buttonRef.current);

    // Xử lý sự kiện khi nút được nhấn
    clipboard.on('success', () => {
      console.log('Đã sao chép thành công!');
    });

    // Xử lý sự kiện khi có lỗi trong quá trình sao chép
    clipboard.on('error', () => {
      console.error('Sao chép thất bại');
    });

    // Hủy đăng ký sự kiện khi component bị hủy
    return () => {
      if (clipboard) {
        clipboard.destroy();
      }
    };
  }, []); // Chỉ chạy một lần sau khi component được render

  return (
    <button ref={buttonRef} data-clipboard-text={text}>
      Sao Chép Text
    </button>
  );
};

export default CopyButton;
